<div class="p-grid">
  <div class="p-col-12" *ngIf="entityObj.errorMessage">
    <p-message severity="error" text="{{entityObj.errorMessage}}" class="p-d-block"></p-message>
  </div>
  <div class="p-col-12">
    <!--<p-gmap #gmap [options]="options" [overlays]="overlays" (onMapReady)="setMap($event)" (onOverlayDragEnd)="markerDrag($event)" [style]="{ width: '100%', height: '400px' }"></p-gmap>-->
    <google-map
      height="400px"
      width="100%"
      [center]="center"
      [zoom]="zoom">
      <map-marker
        *ngIf="markerPosition"
        [position]="markerPosition"
        [options]="{
          draggable: true,
          label: {
            text: this.text || '',
            color: 'black',
            fontWeight: 'bold',
            fontSize: '16px'
          }
        }"
        (mapDragend)="markerDragEnd($event)">
      </map-marker>
    </google-map>
  </div>
  <div class="p-col p-field p-right">
    <p-button label="{{'component.maps.save_position' | translate}}" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
  </div>
</div>

